<page-header title="EXPORT_AUDIT_LOGS"></page-header>

<card>
  <form [formGroup]="form">
    <div class="field">
      <label
        style="font-size: 13px"
        class="label"
        translationEditableDirective="DATE_FROM"
        >{{ 'DATE_FROM' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          formControlName="from"
          name="from"
          placeholder="Date start"
          [ngClass]="{ 'is-danger': validationErrors.from }"
        />
      </div>

      <p class="help is-danger" *ngIf="validationErrors.from">
        {{ validationErrors.from }}
      </p>
    </div>

    <div class="field">
      <label
        style="font-size: 13px"
        class="label"
        translationEditableDirective="DATE_TO"
        >{{ 'DATE_TO' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          [ngClass]="{ 'is-danger': validationErrors.to }"
          formControlName="to"
          name="to"
          [placeholder]="'DATE_END' | translate"
        />

        <p class="help is-danger" *ngIf="validationErrors.to">
          {{ validationErrors.to }}
        </p>
      </div>
    </div>
  </form>
  <button
    class="button is-info"
    [disabled]="isLoading"
    [ngClass]="{ 'is-loading': isLoading }"
    (click)="export()"
    translationEditableDirective="EXPORT"
  >
    {{ 'EXPORT' | translate }}
  </button>
</card>
